import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';



// Define RTL languages
export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Initialize react-i18next
    .init({
        resources: {
            en: {
                common: require("../locales/en/commonTranslation.json"),
                eula: require('../locales/en/eulaTranslation.json'),
                signIn: require('../locales/en/signInTranslation.json'),
                signUp: require('../locales/en/signUpTranslation.json'),
                confirmation: require('../locales/en/confirmationTranslation.json'),
                termsAndConditions: require('../locales/en/termsAndConditions.json'),
                dashboard: require('../locales/en/dashboardTranslation.json'),
                sideNav: require('../locales/en/sideNavTranslation.json'),
                invoice: require('../locales/en/InvoiceTranslation.json'),
                reportIssue: require('../locales/en/reportIssueTranslation.json'),
                navBar: require('../locales/en/navBarTranslation.json'),
                profile: require('../locales/en/profileTranslation.json'),
                resetPassword: require('../locales/en/resetPasswordTranslation.json'),
                editor: require('../locales/en/editorTranslation.json'),
                publicationsTranslation: require('../locales/en/publicationsTranslation.json'),
                cardItem: require('../locales/en/cardItemTranslation.json'),
                regenerateServices: require('../locales/en/regenerateServicesTranslation.json'),
                welcomeCard: require('../locales/en/welcomeCardTranslation.json'),
                chatbot: require('../locales/en/chatbotTranslations.json'),
            },
            ar: {
                common: require("../locales/ar/commonTranslation.json"),
                eula: require('../locales/ar/eulaTranslation.json'),
                signIn: require('../locales/ar/signInTranslation.json'),
                signUp: require('../locales/ar/signUpTranslation.json'),
                confirmation: require('../locales/ar/confirmationTranslation.json'),
                termsAndConditions: require('../locales/ar/termsAndConditions.json'),
                dashboard: require('../locales/ar/dashboardTranslation.json'),
                sideNav: require('../locales/ar/sideNavTranslation.json'),
                invoice: require('../locales/ar/InvoiceTranslation.json'),
                reportIssue: require('../locales/ar/reportIssueTranslation.json'),
                navBar: require('../locales/ar/navBarTranslation.json'),
                profile: require('../locales/ar/profileTranslation.json'),
                resetPassword: require('../locales/ar/resetPasswordTranslation.json'),
                editor: require('../locales/ar/editorTranslation.json'),
                publicationsTranslation: require('../locales/ar/publicationsTranslation.json'),
                cardItem: require('../locales/ar/cardItemTranslation.json'),
                regenerateServices: require('../locales/ar/regenerateServicesTranslation.json'),
                welcomeCard: require('../locales/ar/welcomeCardTranslation.json'),
                chatbot: require('../locales/ar/chatbotTranslations.json'),
            }
        },
        fallbackLng: 'en',
        load: 'languageOnly',
        nonExplicitSupportedLngs: true,
        supportedLngs: ['en', 'ar'],
        detection: {
            order: ['localStorage', 'cookie', 'navigator'],
            caches: ['localStorage', 'cookie'],
        },
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: true
        }
    });

export default i18n;
